import {SentryConstants} from '../constants/sentry/sentry-constants';
import {SentryTracesSamplerContext} from '../../models/sentry.model';

/**
 * Method: Sample a trace at the given rate, never where tracing is off or for the OIDC callback
 * @param context - Name and parent decision of the span to sample
 * @param rate - Trace sample rate of the environment
 */
export function sampleSentryTrace(context: SentryTracesSamplerContext, rate: number): number {
  return rate === 0 || context.name.startsWith(SentryConstants.OIDC_CALLBACK_PATH)
    ? 0
    : context.inheritOrSampleWith(rate);
}
